module.exports = __webpack_public_path__ + "img/MEDIA024.f5048d13.jpg";